import { Link } from "react-router-dom";
import { FlaskConical, BookOpen, BarChart3, MapPinned } from "lucide-react";
import StageSection from "./StageSection";

const STATS = [
  { label: "Prichard population", value: "19,322", source: "ACS 5-year, 2022" },
  { label: "Median household income", value: "$30,481", source: "ACS 5-year, 2022" },
  { label: "Mobile County CDBG allocation", value: "$3.2M", source: "HUD CDBG-CV FY24" },
  { label: "Vacant commercial parcels in 36610", value: "120+", source: "Mobile County GIS" },
];

const PlanStage = () => {
  return (
    <StageSection
      id="plan"
      number="02"
      eyebrow="Plan · Research & Insights"
      title="Ground every idea in county-level data and prior work."
      intro="The Prichard Mall pitch isn't a hunch — it's an ACS query, a HUD allocation, and a parcel map. Our research tools turn that data into briefs you can hand a council member or a funder."
      icon={FlaskConical}
      ctaLabel="Explore data tools"
      ctaHref="/data-tools"
      tone="alt"
    >
      <div className="space-y-4">
        <div className="rounded-2xl border border-border bg-card p-5 md:p-6">
          <div className="flex items-center gap-2 mb-4 text-xs font-semibold tracking-wider uppercase text-primary">
            <MapPinned className="h-4 w-4" /> Prichard snapshot
          </div>
          <div className="grid grid-cols-2 gap-4">
            {STATS.map((s) => (
              <div key={s.label} className="border-l-2 border-primary/30 pl-3">
                <div className="font-display text-xl md:text-2xl font-bold text-foreground">
                  {s.value}
                </div>
                <div className="text-xs text-muted-foreground leading-tight mt-0.5">
                  {s.label}
                </div>
                <div className="text-[10px] uppercase tracking-wider text-muted-foreground/70 mt-1">
                  {s.source}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          <Link
            to="/insights"
            className="group rounded-2xl border border-border bg-card p-5 hover:border-primary/40 transition-all"
          >
            <BookOpen className="h-5 w-5 text-primary mb-3" />
            <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">
              Research & Insights
            </div>
            <h4 className="font-display font-semibold text-foreground leading-snug">
              Briefs, priority zip codes, and the methodology behind every number
            </h4>
          </Link>
          <Link
            to="/data-tools"
            className="group rounded-2xl border border-border bg-card p-5 hover:border-primary/40 transition-all"
          >
            <BarChart3 className="h-5 w-5 text-primary mb-3" />
            <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">
              Data Explorer
            </div>
            <h4 className="font-display font-semibold text-foreground leading-snug">
              Run your own ACS pulls by tract, zip, or county
            </h4>
          </Link>
        </div>
      </div>
    </StageSection>
  );
};

export default PlanStage;